import React, { useState, useEffect } from "react";
import { Menu, Layout, notification, Modal } from "antd";
import { BookOutlined, QuestionCircleOutlined, FieldTimeOutlined } from "@ant-design/icons";
import { Link, Redirect, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";
/* CUSTOM COMPONENTS */
import { Container } from "./SidebarStyle";

/* Actions */
import {
  getDoctorDetail,
  getDoctorDetailReset,
} from "../../action/getDoctorDetailAction";

/*  */
import { s3_cdn } from "../../utils";
import {
  BookAppointmentIcon,
  CalenderIcon,
  EmergencyDtrfDashboardIcon,
  EmergencyDtrfIcon,
  FnfIcon,
  HomeLoveIcon,
  LogoutIcon,
  PatientIcon,
  PatientsIcon,
  ReportsIcon,
  ReviewsIcon,
  ScheduleTimingIcon,
  UserProfileIcon,
} from "../CustomIcons";
import { DownloadOutlined, SearchOutlined } from "@ant-design/icons"

import { getArticleTags, getArticleTagsReset } from "../../action/getArticleTagsAction";
const { Sider } = Layout;
const Sidebar = (props) => {
  // variables
  /* variable & state */
  const { getDoctorDetail, getDoctorDetailState, getDoctorDetailReset, getArticleTags, getArticleTagsState, getArticleTagsReset } = props;
  const { SubMenu } = Menu;
  const [redirect, setRedirect] = useState(false);
  const [doctor, setDoctor] = useState({
    name: "",
    speciality: "",
    profile_picture: "",
    is_dcp_activated: "",
    is_dtrf_activated: "",
  });
  const [defaultKey, setDefaultKey] = useState("");
  const location = useLocation();
  const [articleTagList, setArticleTagList] = useState([]);



  // Fetch article tags on component mount
  useEffect(() => {
    getArticleTags(); // Fetch article tags from the API
    return () => {
      getArticleTagsReset(); // Reset the article tags on component unmount
    };
  }, []);


  // Set article tags list when API call is successful
  useEffect(() => {
    if (getArticleTagsState.apiState === "success") {
      setArticleTagList(getArticleTagsState.list);
    }
  }, [getArticleTagsState]);

  //Callback
  useEffect(() => {
    switch (location.pathname) {
      case "/":
        return setDefaultKey("1");
      case "/article-read":
        return setDefaultKey("1");
      case "/article-watch":
        return setDefaultKey("1");
      case "/article-listen":
        return setDefaultKey("1");
      case "/appointment":
        return setDefaultKey("3");
      case "/appointment/save":
        return setDefaultKey("4");
      case "/schedule":
        return setDefaultKey("5");
      case "/patient":
        return setDefaultKey("6");
      case "/reports":
        return setDefaultKey("8");
      case "/emeregency-dtrf":
        return setDefaultKey("11");
      case "/emeregency-dtrf/dashboard":
        return setDefaultKey("12");
      case "/test-book":
        return setDefaultKey("14");
      case "/QuickSupport":
        return setDefaultKey("18");
      case "/dtrfs":
        return setDefaultKey("16");
      case "/dtrf_form":
        return setDefaultKey("17");
      // case '/Test':
      //   return setDefaultKey("16");
      default:
        if (location.pathname.includes("/article-detail")) {
          return setDefaultKey("1");
        } else if (location.pathname.includes("/patient/edit")) {
          return setDefaultKey("6");
        }
        return setDefaultKey("1");
    }
  }, [location]);
  useEffect(() => {
    getDoctorDetail();
    return () => {
      getDoctorDetailReset();
    };
  }, []);

  useEffect(() => {
    if (getDoctorDetailState.apiState === "success") {
      localStorage.setItem(
        "LilacDoctorActivate",
        getDoctorDetailState.data.activate_status
      );
      let speciality = [];
      _.each(getDoctorDetailState.data.speciality, (obj) => {
        speciality.push(obj.value);
      });
      setDoctor({
        ...doctor,
        ["name"]:
          getDoctorDetailState.data.fname +
          " " +
          getDoctorDetailState.data.lname,
        ["speciality"]: _.join(speciality, ", "),
        ["profile_picture"]: getDoctorDetailState.data.profile_picture
          ? `${s3_cdn()}doctor/${getDoctorDetailState.data.profile_picture}`
          : "",
        ["is_dcp_activated"]: getDoctorDetailState.data.is_dcp_activated,
        ["is_dtrf_activated"]: getDoctorDetailState.data.is_dtrf_activated,
      });
    }
    else if (getDoctorDetailState.apiState === "error") {
      // if(getDoctorDetailState.error_status==403)
      // {
      window.location.replace("/login");
      // }
    }
  }, [getDoctorDetailState]);

  //Functions
  const logout = () => {
    Modal.confirm({
      content: "Are you sure you want to sign out?",
      onOk: () => {
        localStorage.removeItem("LilacDoctorToken");
        localStorage.removeItem("LilacDoctor");
        setRedirect(true);
        window.location.reload();
        notification.success({
          message: "You are logged out successfully.",
          placement: "bottomRight",
        });
      },
      okButtonProps: {
        className: "borderPrimary"
      },
      cancelButtonProps: {
        className: "borderNonPrimary",
      },
    });
  };

  return (
    <>
      {redirect && <Redirect to="/login" />}
      <Sider
        trigger={null}
        width={280}
        breakpoint="lg"
        collapsedWidth="0"
        onBreakpoint={(broken) => {
          props.toggle(broken);
        }}
        collapsed={props.collapsed}
        style={{
          overflow: "auto",
          height: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          bottom: 0,
        }}
        className="site-layout-background sidebarScroll"
      >
        <Container>
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "flex-start",
              flexDirection: "column",
              padding: 20,
            }}
          >
            {/* <span style={{ width: 140, height: 140, borderRadius: 70, background: "#f7f7f7", padding: 8 }} >
              {doctor.profile_picture &&
                <img style={{ width: "100%", height: "100%", borderRadius: 100 }} src={doctor.profile_picture} />
              }
            </span> */}

            <span style={{ width: 60, height: 100 }}>
              {/* {doctor.profile_picture && ( */}
              <img src="/images/Lilac-Insights-Logo-purple.png" />
              {/* )} */}
            </span>

            <span style={{ fontWeight: 530, fontSize: 22 }}>Hi Dr.</span>
            <span style={{ fontWeight: 530, fontSize: 22 }}>
              {" "}
              {doctor.name}
            </span>
          </div>
          {defaultKey && (
            <Menu
              className="sidebarMenus"
              style={{ width: "100%" }}
              defaultSelectedKeys={[defaultKey]}
            // defaultOpenKeys={['sub1']}
            >
              <Menu.Item key="1" icon={<HomeLoveIcon size={24} />}>
                <Link to="/">Home</Link>
              </Menu.Item>
              {getDoctorDetailState.apiState === "success" &&
                getDoctorDetailState.data.activate_status === "active" && (
                  <>
                    <Menu.Item key="9" icon={<UserProfileIcon size="24" />}>
                      <Link to={"/ProfileSetting"}>Profile</Link>
                    </Menu.Item>
                    {getDoctorDetailState.data.is_dcp_activated == "Yes" && (
                      <Menu.Item key="3" icon={<CalenderIcon size="24" />}>
                        <Link to={"/appointment"}>Upcoming Bookings</Link>
                      </Menu.Item>
                    )}
                    {/* <Menu.Item key="13" icon={<FieldTimeOutlined />}>
              <Link to="/article">
                Article
              </Link>
            </Menu.Item> */}
                    {getDoctorDetailState.data.is_dtrf_activated == "Yes" && (
                      <Menu.Item
                        key="17"
                        icon={<EmergencyDtrfDashboardIcon size="24" />}
                      >
                        <Link to={"/dtrf-form"}>Request/Order Test</Link>
                      </Menu.Item>
                    )}
                    {getDoctorDetailState.data.is_dcp_activated == "Yes" && (
                      <Menu.Item
                        key="4"
                        icon={<BookAppointmentIcon size="24" />}
                      >
                        <Link to={"/appointment/save"}>
                          Book Consultation for Patient
                        </Link>
                      </Menu.Item>
                    )}
                    {getDoctorDetailState.data.is_dcp_activated == "Yes" && (
                      <Menu.Item
                        key="5"
                        icon={<ScheduleTimingIcon size="24" />}
                      >
                        <Link to={"/schedule"}>Manage Schedule</Link>
                      </Menu.Item>
                    )}
                    <Menu.Item key="8" icon={<ReportsIcon size="24" />}>
                      <Link to={"/reports"}>Test Reports</Link>
                    </Menu.Item>
                    <Menu.Item key="14" icon={<ReportsIcon size="24" />}>
                      <Link to={"/test-book"}>Test Directory</Link>
                    </Menu.Item>
                    <Menu.Item key="6" icon={<PatientsIcon size="24" />}>
                      <Link to={"/patient"}>Patients</Link>
                    </Menu.Item>
                    {getDoctorDetailState.data.is_dtrf_activated == "Yes" && (
                      <Menu.Item
                        key="18"
                        icon={<EmergencyDtrfDashboardIcon size="24" />}
                      >
                        <Link to={"/dtrfs"}>DTRF Dashboard</Link>
                      </Menu.Item>
                    )}
                    {/* <Menu.Item
                      key="12"
                      icon={<EmergencyDtrfDashboardIcon size="24" />}
                    >
                      <Link to={"/emeregency-dtrf/dashboard"}>
                        Emergency Dashboard
                      </Link>
                    </Menu.Item> */}
                    {/* 
                    <Menu.Item key="13" icon={<FieldTimeOutlined />}>
                      <Link to="/article">
                        Article
                      </Link>
                    </Menu.Item> */}
                    {/* //todo removed menus after ganesh told */}
                    {/* {doctor.is_dtrf_activated === "Yes" && (
                      <Menu.Item
                        key="11"
                        icon={<EmergencyDtrfIcon size="24" />}
                      >
                        <Link to={"/emeregency-dtrf"}>Emergency Dtrf</Link>
                      </Menu.Item>
                    )}
                    <Menu.Item key="15" icon={<QuestionCircleOutlined style={{fontSize:"23px"}} size="24" />}>
                      <Link to={"/QuickSupport"}>Quick Support</Link>
                    </Menu.Item>
                    <Menu.Item key="7" icon={<ReviewsIcon size="24" />}>
                      <Link to={"/Testimonial"}>Reviews</Link>
                    </Menu.Item> */}

                    <Menu.Item key="16" icon={<BookOutlined style={{ fontSize: "23px" }} size="24" />}>
                      <Link to={"/BookmarkedArticles"}>Bookmarks</Link>
                    </Menu.Item>
                    <Menu.Item key="30" icon={<SearchOutlined style={{ fontSize: "23px" }} size="24" />}>
                      <Link to={{ pathname: "/article-read", state: { fromSidebar: true, key: null } }}>Search FMF</Link>
                    </Menu.Item>
                    <Menu
                      mode="inline"
                    >
                      <SubMenu
                        title="Fetal Medicine Foundation"
                        className="fetal-sidebarMenus"
                        style={{ fontSize: "14px", fontWeight: "500" }}
                        icon={<FnfIcon size="24" />}
                      >
                        {articleTagList.map((tag, index) => (
                          <Menu.Item
                            style={{ paddingLeft: "10px" }}
                            icon={<>
                              <img
                                style={{
                                  width: "20px",
                                  marginRight: "10px"
                                }}
                                alt="example"
                                src={`${tag.icon_url}`}
                              />
                            </>}>
                            <Link
                              key={index}
                              to={{
                                pathname: "/article-read",
                                state: { key: tag.key },
                              }}
                            >
                              {tag.title}
                            </Link>
                          </Menu.Item>
                        ))}

                      </SubMenu>
                    </Menu>
                  </>

                )}

              <Menu.Item
                onClick={logout}
                key="10"
                icon={<LogoutIcon size="24" />}
              >
                Logout
              </Menu.Item>
            </Menu>
          )}

        </Container>
      </Sider>
      <div
        className="overlayDrawerClose"
        onClick={() => props.toggle(!props.collapsed)}
      >
        <button class="overlayDrawerCloseBtn btn">&times;</button>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  getDoctorDetailState: state.getDoctorDetail,
  getArticleTagsState: state.getArticleTags,
});

const mapDispatchToProps = (dispatch) => ({
  getDoctorDetail: (params) => dispatch(getDoctorDetail(params)),
  getDoctorDetailReset: () => dispatch(getDoctorDetailReset()),
  getArticleTags: (params) => dispatch(getArticleTags(params)),
  getArticleTagsReset: () => dispatch(getArticleTagsReset())
});

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
